import { CalendarCheck, User } from "lucide-react";
import { useFormikContext } from "formik";
import { Step, IReservation } from "@/pages/reservations/hooks/useSteps";
import DataCell from "@/components/DataCell";
import SummaryPanel from '@/pages/reservations/components/ConfirmationView/components/SummaryPanel';
import intersection from 'lodash/intersection';
import { formatPhone } from "@/utils/phones";
import { format } from 'date-fns';
import { es } from 'date-fns/locale'

interface StepSummaryProps {
    step: Step;
}

const StepSummary = ({ step }: StepSummaryProps) => {
    const formik = useFormikContext<IReservation>();

    const hasErrors = () => {
        const intfieldsWithErrors = intersection(Object.keys(formik.errors), Object.keys(step?.initialValues ?? {}));
        return !!intfieldsWithErrors.length;
    }

    switch(step.id) {
        case 'contact':
            return (
                <SummaryPanel
                    title="Reserva a nombre de"
                    icon={<User />}
                    stepId={step.id}
                    error={hasErrors() ? "Información imcompleta" : undefined}
                >
                    <DataCell label="Nombre" value={`${formik.values.name} ${formik.values.lastname}`}/>
                    <DataCell label="Teléfono" value={formatPhone(formik.values.phone, 505)}/>
                </SummaryPanel>
            );
        case 'date':
            return (
                <SummaryPanel
                    title="¿Te esperamos!"
                    icon={<CalendarCheck />}
                    stepId={step.id}
                    error={hasErrors() ? "Información imcompleta" : undefined}
                >
                    <DataCell
                        label="Fecha"
                        value={
                            formik?.values?.date 
                                ? format(new Date(formik.values.date), "eeee dd 'de' MMMM 'de' yyyy", { locale: es }) 
                                : undefined
                            }
                        />
                    <DataCell
                        label="Hora"
                        value={
                            formik?.values?.time
                                ? format(new Date(formik.values.time), "h:mm a", { locale: es })
                                : undefined
                        }
                    />
                </SummaryPanel>
            );
    }
}

export default StepSummary;
